
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    prizeIndex: String,
    prizeName: String,
    prizePrice: String,
    prizeImage: String
  }
})
export default class Prize extends Vue {
  // msg!: string;
}
